import { forwardRef, useState } from "react";

import { EyeClosedIcon, EyeIcon } from "@eisox/icons";

import { TextField } from "../TextField";

type PasswordInputProps = Omit<TextField.TextFieldProps, "type">;

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({ children, ...rest }, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField.Root {...rest} ref={ref} type={showPassword ? "text" : "password"}>
      {children}
      <TextField.Slot side="right" onClick={() => setShowPassword(!showPassword)}>
        {showPassword ? (
          <EyeIcon onClick={() => setShowPassword(false)} className={"h-5 w-5 cursor-pointer"} />
        ) : (
          <EyeClosedIcon onClick={() => setShowPassword(true)} className={"h-5 w-5 cursor-pointer"} />
        )}
      </TextField.Slot>
    </TextField.Root>
  );
});

PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
export type { PasswordInputProps };
